import React, { useState, useEffect } from "react";
import useCustomGetStoreState from "../../../hooks/useCustomGetStoreState";
import useDebounceSearch from "../../../hooks/useDebounchSearch";
import HelperMetiers360 from "../../../services/HelpersMetiers360";
import { Alert, Button, Col, Row } from "react-bootstrap";
import Loader from "../../../components/widgets/Loader";
import RelationTypesTableComponent from "../../../components/relationTypes/RelationTypesTableComponent";
import { useStoreActions, useStoreState } from "easy-peasy";
import RelationTypesFormComponent, { submitRelationTypeForm } from "../../../components/relationTypes/RelationTypeFormComponent";
import { useToast } from "../../../hooks/useToast";
import { useModal } from "../../../hooks/useModal";

const RelationTypesPage = () => {
    const { allRelationTypes, isFetchingAllRelationTypes } = useCustomGetStoreState("relationTypes");
    const relationTypesSlugs = useStoreState(state => state.actionSlugs.actionSlugsDispatcher("clientRelationTypes"));
    const { createRelationType } = useStoreActions(actions => actions.relationTypes);

    const toast = useToast();
    const { modalComponent, setModalShow, modalData, setModalData, setIsSending } = useModal();
    const { searchInput, search } = useDebounceSearch({ placeholder: 'Rechercher par nom', delay: 400 });

    const [filteredRelationTypes, setFilteredRelationTypes] = useState(allRelationTypes);

    useEffect(() => {
        setFilteredRelationTypes(allRelationTypes);
    }, [allRelationTypes])

    useEffect(() => {
        if (allRelationTypes) {
            setFilteredRelationTypes([...allRelationTypes.filter(
                relationType => HelperMetiers360.isSearchInText(search, relationType.name))
            ]);
        }
    }, [search, allRelationTypes])

    const openCreateRelationTypesModal = () => {
        const handleSubmit = () => {
            setIsSending(true);
            submitRelationTypeForm({ allRelationTypes, action: createRelationType })
                .then(() => {
                    toast.success();
                    setModalShow(false);
                })
                .finally(() => setIsSending(false));
        }

        setModalData({
            ...modalData,
            header: <>Création d'une nature de la relation client</>,
            content: <RelationTypesFormComponent />,
            cancelButton: 'Annuler',
            onValidate: handleSubmit,
            size: 'xl',
        });
        setModalShow(true);
    };

    const createButton = relationTypesSlugs?.create
        && <Button variant="success" onClick={() => { openCreateRelationTypesModal() }} as="a" >
            <i className="fas fa-plus"></i> &nbsp;Nouvelle
        </Button>

    const isNoRelationTypes = !isFetchingAllRelationTypes && !allRelationTypes.length
    const isNoResult = !isFetchingAllRelationTypes && !!allRelationTypes.length && !filteredRelationTypes.length;

    return <>
        <Row className="item-page">
            <Col>
                {!isFetchingAllRelationTypes && searchInput}
            </Col>
            <Col className="d-flex justify-content-end align-items-center">
                {createButton}
            </Col>
        </Row>

        {isFetchingAllRelationTypes && allRelationTypes.length < 1 && <Loader />}
        {filteredRelationTypes.length > 0 && <RelationTypesTableComponent relationTypesToDisplay={filteredRelationTypes} />}
        {isNoResult && <Alert className="mt-3" variant="warning"> Aucune nature de la relation client ne correspond à votre recherche</Alert>}
        {isNoRelationTypes && <Alert className="mt-3" variant="warning">Vous n'avez accès à aucune nature de la relation client</Alert>}
        {modalComponent}
    </>;
}
export default RelationTypesPage;